export default "__VITE_ASSET__CAc8HbzT__"